<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">PO変更・取消一覧</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search">検索</v-btn>
        <v-btn @click="confirmPo" v-permit.SHARP_PCS_CONFIRM>PO確認</v-btn>
        <!-- <a @click="$watchVideo('B1800-01')" href="#" style="margin-left: 10px">マニュアルビデオDL1</a>
        <a @click="$watchVideo('B1800-02')" href="#" style="margin-left: 10px">マニュアルビデオDL2</a> -->
      </v-card-actions>

      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="海外取引先"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field label="PO NO" v-model="query.poNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-checkbox
                label="確認待ち"
                v-model="query.confirmWait"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.poNo }}</td>
          <td>{{ props.item.buName }}</td>
          <td>{{ props.item.departmentName }}</td>
          <td>{{ props.item.productName }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.skuSupplierCode }}</td>
          <td>{{ props.item.currencyCode }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.unitPrice }}</td>
          <td>{{ status[props.item.status] }}</td>
          <td>{{ props.item.status }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      results: [],
      selected: [],
      loading: false,
      query: {},
      pagination: {
        page: 1,
      },
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '事業本部', value: 'buName', sortable: false },
        { text: '事業部', value: 'departmentName', sortable: false },
        { text: '品種', value: 'productName', sortable: false },
        { text: '社内品番', value: 'skuInnerCode', sortable: false },
        { text: '社外品番', value: 'skuOuterCode', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '発注数量', value: 'qty', sortable: false },
        { text: '発注単価', value: 'unitPrice', sortable: false },
        { text: 'PO変更・取消', value: 'poOperating', sortable: false },
        { text: '処理Status', value: 'status', sortable: false },
      ],
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          status: ['CANCEL', 'CONFLICT'],
        },
        paramsSerializer: (params) => {
          return this.$qs.stringify(params, { indices: false })
        },
      }
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/purchase-orders/status', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    confirmPo() {
      this.$router.push({
        path: '/B1801',
        query: {
          poStatus: this.selected[0].status,
          poNo: this.selected[0].poNo,
          conflictId: this.selected[0].id,
          normalId: this.selected[0].sourcePoId,
        },
      })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  mounted() {
    this.$loadParams()
  },
}
</script>

